import { container } from '../utils/container/container';
import { ServiceIds } from '../utils/container/service-ids';
import { FeatureFlagsLoader } from '../utils/feature-flags/feature-flags-loader';
import { FlagNames } from '../utils/feature-flags/flag-names';

export class LpAssetsResolver {
    static getRelativePath(img: string): string {
        const flagLoader = container.get<FeatureFlagsLoader>(ServiceIds.FEATURE_FLAG_LOADER);
        const lpDirectories = flagLoader.get(FlagNames.LP_DIRECTORIES);

        if (lpDirectories.isOn()) {
            return `https:${window.app.config.cdn.lp_web}${img}`;
        }

        return `https:${window.app.config.cdn.lp_web}static/lpgenerator/${img}`;
    }
}
